import { readJson, writeJson } from './storage'

const KEY = 'veracruz.myStages'

// Registro de etapas hechas (alcance v1): vive SOLO en el dispositivo; no va al backend.
// Etapa → fecha (AAAA-MM-DD) en que se marcó.
export type MyStages = Record<string, string>

export const readMyStages = (storage?: Storage): MyStages => {
	const value = readJson<unknown>(KEY, {}, storage)
	if (typeof value !== 'object' || value === null || Array.isArray(value)) return {}
	return Object.fromEntries(Object.entries(value).filter(([, date]) => typeof date === 'string')) as MyStages
}

// Día del calendario en España (no en UTC): una etapa marcada a las 00:30 cuenta para ese día.
export const madridDay = (date: Date): string =>
	new Intl.DateTimeFormat('en-CA', {
		timeZone: 'Europe/Madrid',
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	}).format(date)

export const markStageDone = (stageId: string, date: Date, storage?: Storage): MyStages => {
	const next = { ...readMyStages(storage), [stageId]: madridDay(date) }
	writeJson(KEY, next, storage)
	return next
}

export const unmarkStage = (stageId: string, storage?: Storage): MyStages => {
	const { [stageId]: _removed, ...rest } = readMyStages(storage)
	writeJson(KEY, rest, storage)
	return rest
}
